export default "__VITE_ASSET__uycywPmy__"